import React, { useRef, useState } from 'react';
import styles from './CustomSlider.module.css';

export interface AlertSliderProps {
  value?: number;
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  className?: string;
}

//Used for severity slider in Create Radial Alert due to different handling compared to Custom Slider
const AlertSlider: React.FC<AlertSliderProps> = ({
  className = '',
  value = 25,
  min = 0,
  max = 99,
  step = 1,
  disabled = false,
  onChange = () => {},
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const sliderRef = useRef<HTMLInputElement>(null);

  return (
    <div
      style={{ position: 'relative', width: '100%' }}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <input
        ref={sliderRef}
        type="range"
        className={`w-100 mx-auto d-block my-2 cursor-pointer ${styles.whiteSlider} ${className}`}
        name="severity"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={onChange}
        disabled={disabled}
        title="Severity slider"
        style={{
          ['--slider-bg' as any]: `linear-gradient(90deg, #f5f5f5 ${(value / max) * 100}%, #222 ${(value / max) * 100}%)`,
        }}
      />
      <div
        className={`${styles.sliderTooltip} ${showTooltip ? styles.sliderTooltipVisible : ''}`}
        style={{
          left: sliderRef.current
            ? `${((value - min) / (max - min)) * (sliderRef.current.offsetWidth - 18) + 9}px`
            : '50%',
        }}
      >
        {value}
        <span className={styles.sliderTooltipArrow} />
      </div>
    </div>
  );
};

export default AlertSlider;
